import React from "react";
import {Envelope, ChatDots} from "react-bootstrap-icons";

export const NotifyEvents = {
    // For reloading all subscriptions
    subscriptionsChanged: "Notify.subscriptionsChanged",
    // For closing edit subscription modal after update
    subscriptionUpdated: "Notify.subscriptionUpdated"
}

export const ProtocolLabels = {
    "email": {
        text: "Email",
        icon: Envelope,
        combo: (
            <>
                <Envelope title="Email" aria-hidden={true} className="fs-4" />
                <span>Email:</span>
            </>
        )
    },
    "sms": {
        text: "SMS/Text",
        icon: ChatDots,
        combo: (
            <>
                <ChatDots title="SMS/Text" aria-hidden={true} className="fs-4" />
                <span>SMS/Text:</span>
            </>
        )
    }
}
